import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntGeozoneIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props} viewBox="0 0 28 28">
      <g clipPath="url(#clip0_327_266)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.58576 8.41419L0 13.9999L14 27.9999L28 13.9999L22.4142 8.41418L21 9.8284L21.682 10.5104L13.9498 18.2427L6.26773 10.5606L6.99997 9.8284L5.58576 8.41419ZM17.1569 16.4498L22.3891 11.2175L25.1716 13.9999L19.9393 19.2322L17.1569 16.4498ZM11.2176 22.3891L16.4498 17.1569L19.2322 19.9393L14 25.1715L11.2176 22.3891ZM13.2426 18.9498L10.5104 21.682L2.82843 13.9999L5.56062 11.2677L13.2426 18.9498Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 7L14 0L21 7L14 14L7 7ZM16.7574 7L14 9.75736L11.2426 7L14 4.24264L16.7574 7Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_327_266">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </SntIcon>
  );
};

export default SntGeozoneIcon;
